import { render } from "./PagePanduan.vue?vue&type=template&id=0593c332"
import script from "./PagePanduan.vue?vue&type=script&lang=js"
export * from "./PagePanduan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__